// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/popup/index.css
// module id = 54
// module chunks = 32